import * as React from "react";
import { useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Title from "../Title";
import { useDispatch, useSelector } from "react-redux";
import {
  clearParameters,
  removeParameter,
  setParameters,
} from "../../redux/global/actions";
import { useNavigate, useSearchParams } from "react-router-dom";
import Button from "@mui/material/Button";
import MultiValueInput from "../../inputs/multiValueInput";
import {
  Fab,
  Grid,
  Menu,
  MenuItem,
  Modal,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import "./MissingSnsStatus.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";

import {
  filterMissingSnsStatus,
  getMissingSnsStatus,
  getMissingSnsStatusBulk,
  sortMissingSnsStatus,
} from "../../redux/dynamo_db/actions";
import MultiSelector from "../../inputs/MultiSelector";
import {
  downloadCSV,
  downloadJSON,
  extractUserInfoFromToken,
  getLocalStorageSAMLToken,
} from "../../utils";

export default function MissingSnsStatus() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasProcessedUrlParams = React.useRef(false);

  const queryParameters = useSelector(
    (state) => state?.parameters?.missingSnsStatus,
  );

  const [currentSerialNumber, setCurrentSerialNumber] = React.useState();

  const [filterTag, setFilterTag] = React.useState([]);
  const [filterSerialNumber, setFilterSerialNumber] = React.useState([]);
  const [filterPartNumbers, setFilterPartNumbers] = React.useState([]);
  const [filterStatus, setFilterStatus] = React.useState();

  const handleExecuteSearch = () => {
    let queryObject = {};
    if (queryParameters.serialNumbers) {
      queryObject.serial_numbers = queryParameters.serialNumbers;
    }
    if (queryParameters.status) {
      queryObject.missing_status = queryParameters.status;
    }
    dispatch(getMissingSnsStatus(queryObject));
  };
  const handleExportMissingSnsStatus = (missingSnsStatus, format = "csv") => {
    const fields = [
      { name: "missing_sns_status_identifier" },
      { name: "serial_number" },
      { name: "created_day", value: "created_at" }, // Maps to created_at in data
      { name: "status", value: "sn_status" }, // Maps to sn_status in data
      { name: "part_number" },
      { name: "missing_detection_location", value: "tag" }, // Maps to tag in data
    ];

    if (format === "csv") {
      downloadCSV(fields, "missing_sns_status_export", ",", missingSnsStatus);
    } else {
      downloadJSON(fields, "missing_sns_status_export", missingSnsStatus);
    }
  };
  const handleExecuteFilter = () => {
    let filterObject = {};
    if (filterSerialNumber?.length > 0) {
      filterObject.serialNumbers = [filterSerialNumber];
    }
    if (filterPartNumbers?.length > 0) {
      filterObject.partNumbers = [filterPartNumbers];
    }
    if (filterTag?.length > 0) {
      filterObject.tags = [filterTag];
    }
    if (filterStatus?.length > 0) {
      filterObject.status = [filterStatus];
    }
    dispatch(filterMissingSnsStatus(filterObject));
  };

  const handleExecuteBulkSearch = () => {
    let queryObject = {};
    if (queryParameters.serialNumbers) {
      queryObject.serial_numbers = queryParameters.serialNumbers;
    }
    if (queryParameters.status) {
      queryObject.missing_status = queryParameters.status;
    }
    queryObject.bulk = true;
    const saml_token = getLocalStorageSAMLToken();
    const infoToken = extractUserInfoFromToken(saml_token);
    queryObject.email = infoToken.email;
    queryObject.request_user = infoToken.username;
    dispatch(getMissingSnsStatusBulk(queryObject));
  };

  useEffect(() => {
    handleExecuteFilter();
  }, [filterSerialNumber, filterPartNumbers, filterStatus, filterTag]);

  // Reset the URL processing flag when the URL actually changes
  useEffect(() => {
    hasProcessedUrlParams.current = false;
  }, [searchParams.toString()]);

  const handleDeleteSerialNumber = (chipToDelete) => () => {
    dispatch(
      removeParameter({ missingSnsStatus: { serialNumbers: [chipToDelete] } }),
    );
  };
  const handleClearSerialNumber = () => {
    dispatch(clearParameters({ missingSnsStatus: "serialNumbers" }));
  };
  const handleDeleteStatus = (chipToDelete) => () => {
    dispatch(removeParameter({ missingSnsStatus: { status: [chipToDelete] } }));
  };
  const handleClearStatus = () => {
    dispatch(clearParameters({ missingSnsStatus: "status" }));
  };

  const missingSnsStatus = useSelector((state) => {
    if (state.filteredMissingSnsStatus) {
      return state.filteredMissingSnsStatus.map((missing_sns_status) => {
        return {
          missing_sns_status_identifier:
            missing_sns_status?.PK + missing_sns_status?.SK,
          serial_number: missing_sns_status?.serial_number,
          created_at: missing_sns_status?.created_at,
          sn_status: missing_sns_status?.sn_status,
          device_type: missing_sns_status?.device_type,
          part_number: missing_sns_status?.part_number,
          tag: missing_sns_status?.tag,
        };
      });
    } else return [];
  });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(document.getElementById("menuAnchor"));
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const filterDescription =
    "Add filters to the list of results, and export the filtered list to CSV (currently not implemented for dataqualitysaporders)";

  const [sortDirection, setSortDirection] = React.useState("");
  const [sortParameter, setSortParameter] = React.useState("");

  const handleSortMissingSnsStatus = (sortParameter) => {
    setSortParameter(sortParameter);
    if (sortDirection === "") {
      setSortDirection("ascending");
      dispatch(sortMissingSnsStatus(sortParameter, "ascending"));
    } else if (sortDirection === "ascending") {
      setSortDirection("descending");
      dispatch(sortMissingSnsStatus(sortParameter, "descending"));
    } else {
      setSortDirection("ascending");
      dispatch(sortMissingSnsStatus(sortParameter, "ascending"));
    }
  };

  const [openBulkConfirmation, setOpenBulkConfirmation] = React.useState(false);

  const statusValues = [
    "MISSING",
    "Known in DatCol",
    "Not shipped to hub",
    "Unknown by ALE",
    "SN created",
  ];

  const handleKeydown = (event) => {
    if (event.key === "Enter") {
      event.stopPropagation();
      event.preventDefault();
      setTimeout(() => {
        handleExecuteSearch();
      }, 0);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeydown);
    return () => {
      document.removeEventListener("keydown", handleKeydown);
    };
  }, []);

  return (
    <React.Fragment>
      <Modal
        open={openBulkConfirmation}
        style={{
          textAlign: "center",
          paddingTop: "45vh",
        }}
      >
        <>
          <Typography style={{ color: "white" }}>
            This query could take a few minutes, are you sure you want to
            continue?
          </Typography>
          <div style={{ paddingBottom: "1%" }} />
          <Grid container className="headercontainer">
            <Grid item>
              <Button
                style={{
                  color: "white",
                  background: "#6b469e",
                }}
                onClick={() => {
                  handleExecuteBulkSearch();
                  setOpenBulkConfirmation(false);
                }}
              >
                Yes
              </Button>
            </Grid>
            <Grid item style={{ width: "7%" }} />
            <Grid item>
              <Button
                style={{
                  color: "white",
                  background: "#6b469e",
                }}
                onClick={() => setOpenBulkConfirmation(false)}
              >
                No
              </Button>
            </Grid>
          </Grid>
        </>
      </Modal>
      <MultiValueInput
        setCurrentParam={setCurrentSerialNumber}
        setQueryParams={setParameters}
        currentParam={currentSerialNumber}
        queryParams={queryParameters?.serialNumbers}
        handleDelete={handleDeleteSerialNumber}
        handleClear={handleClearSerialNumber}
        label="Serial Number"
        family="missingSnsStatus"
        type="serialNumbers"
      />
      <MultiSelector
        setQueryParams={setParameters}
        queryParams={queryParameters?.status}
        handleDelete={handleDeleteStatus}
        handleClear={handleClearStatus}
        label="Status"
        family="missingSnsStatus"
        type="status"
        options={statusValues}
      />
      <Grid
        container
        style={{
          justifyContent: "center",
        }}
      >
        <Grid item>
          <Button
            variant="contained"
            onClick={handleExecuteSearch}
            style={{ width: "15vw" }}
          >
            Search
          </Button>
        </Grid>
        <div style={{ paddingLeft: "0.2%" }} />
        <Grid item>
          <Button
            variant="contained"
            onClick={() => setOpenBulkConfirmation(true)}
            style={{ width: "15vw" }}
          >
            Bulk Export
          </Button>
        </Grid>
      </Grid>
      <Title>Missing Serial Numbers Status</Title>
      <Typography>
        {missingSnsStatus?.length
          ? missingSnsStatus?.length === 100
            ? missingSnsStatus?.length + " results, use bulk export for more"
            : missingSnsStatus?.length + " results"
          : null}
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Serial number"
                    variant="standard"
                    onChange={(e) => {
                      setFilterSerialNumber(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortMissingSnsStatus("serial_number")}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "serial_number" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "serial_number" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>Created day</Grid>
                <Grid
                  item
                  onClick={() => handleSortMissingSnsStatus("created_at")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "created_at" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "created_at" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Status"
                    variant="standard"
                    onChange={(e) => {
                      setFilterStatus(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortMissingSnsStatus("sn_status")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "sn_status" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "sn_status" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Part Number"
                    variant="standard"
                    onChange={(e) => {
                      setFilterPartNumbers(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortMissingSnsStatus("part_number")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "part_number" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "part_number" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Missing detection location"
                    variant="standard"
                    onChange={(e) => {
                      setFilterTag(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortMissingSnsStatus("tag")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" && sortParameter === "tag" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "tag" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {missingSnsStatus.map((row) => (
            <React.Fragment key={row?.missing_sns_status_identifier}>
              <TableRow
                hover
                style={{
                  cursor: "pointer",
                }}
              >
                <TableCell>{row?.serial_number}</TableCell>
                <TableCell>{row?.created_at}</TableCell>
                <TableCell>{row?.sn_status}</TableCell>
                <TableCell>{row?.part_number}</TableCell>
                <TableCell>{row?.tag}</TableCell>
              </TableRow>
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
      <Tooltip
        title={<Typography fontSize={17}>{filterDescription}</Typography>}
      >
        <Fab
          style={{
            position: "absolute",
            right: 10,
            bottom: 10,
            backgroundColor: "#6b469e",
            color: "white",
            height: "5em",
            width: "5em",
          }}
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <div
            id="menuAnchor"
            style={{
              position: "relative",
              bottom: 500,
              right: 250,
            }}
          ></div>
          <FileDownloadIcon
            fontSize="large"
            style={{ height: "70%", width: "70%" }}
          />
        </Fab>
      </Tooltip>
      <div>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem>
            <TextField
              label="Serial number"
              onChange={(e) => {
                setFilterSerialNumber(e.target.value);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            />
          </MenuItem>
          <MenuItem>
            <TextField
              label="Status"
              onChange={(e) => {
                setFilterStatus(e.target.value);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            />
          </MenuItem>
          <MenuItem>
            <TextField
              label="Part Number"
              onChange={(e) => {
                setFilterPartNumbers(e.target.value);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            />
          </MenuItem>
          <MenuItem>
            <TextField
              label="Missing detection location"
              onChange={(e) => {
                setFilterTag(e.target.value);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            />
          </MenuItem>
          <MenuItem hover="false">
            <Button
              variant="contained"
              onClick={() => {
                handleExportMissingSnsStatus(missingSnsStatus, "csv");
              }}
            >
              Export Missing SNS Status as CSV
            </Button>
          </MenuItem>
          <MenuItem hover="false">
            <Button
              variant="contained"
              onClick={() => {
                handleExportMissingSnsStatus(missingSnsStatus, "json");
              }}
            >
              Export Missing SNS Status as JSON
            </Button>
          </MenuItem>
        </Menu>
      </div>
    </React.Fragment>
  );
}
